import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withModifiers as _withModifiers, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  "txt-center": "",
  "m-t-0": ""
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  "txt-center": ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_opportunity_congrats = _resolveComponent("app-opportunity-congrats")!
  const _component_app_skill_input = _resolveComponent("app-skill-input")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_app_location_search = _resolveComponent("app-location-search")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      "custom-class": "App-Create-Opportunity-Modal App-Unpadded",
      "model-value": _ctx.isModalOpen,
      width: "550px",
      onOpen: _ctx.opened,
      onClose: _ctx.closeModal,
      title: _ctx.title,
      center: "",
      "show-close": _ctx.showClose,
      "close-on-click-modal": _ctx.showClose,
      "close-on-press-escape": _ctx.showClose,
      "append-to-body": true,
      "lock-scroll": true,
      "open-delay": 200,
      "close-delay": 200
    }, {
      footer: _withCtx(() => [
        (!_ctx.isShowingCongrats)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_el_button, {
                "is-block": "",
                icon: "el-icon-check",
                onClick: _ctx.submit,
                size: "large",
                type: "primary",
                disabled: _ctx.disabledSave || _ctx.loading
              }, {
                default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                  _createTextVNode(" Add Opportunity ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick", "disabled"])
            ]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_scrollbar, {
          always: true,
          "max-height": "500px"
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", null, [
              (_ctx.isShowingCongrats)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_app_opportunity_congrats, {
                      onSubmit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isShowingCongrats = false))
                    })
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isShowingCongrats)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (_ctx.skills !== undefined)
                      ? (_openBlock(), _createBlock(_component_el_form, {
                          key: 0,
                          onSubmit: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["prevent"])),
                          class: "App-Styled-Form",
                          "label-position": 'top',
                          "label-width": "100px",
                          model: _ctx.form,
                          style: {"margin-top":"12px"},
                          rules: _ctx.rules
                        }, {
                          default: _withCtx(() => [
                            (_ctx.business)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                  _cache[15] || (_cache[15] = _createElementVNode("h3", {
                                    "txt-center": "",
                                    "f-w-700": "",
                                    "m-tb-0": ""
                                  }, "Creating for:", -1)),
                                  _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.business.name), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_app_skill_input, {
                              modelValue: _ctx.form.skill,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.skill) = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_el_form_item, {
                              prop: "talents",
                              label: "Number of talents"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input_number, {
                                  "w-100": "",
                                  controls: false,
                                  placeholder: "EX: 2",
                                  modelValue: _ctx.form.talents,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.talents) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              prop: "outcome",
                              label: "What is the opportunity outcome?"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  placeholder: "Build an MVP web app",
                                  modelValue: _ctx.form.outcome,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.outcome) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_divider),
                            _createVNode(_component_el_space, {
                              "w-100": "",
                              style: {"justify-content":"space-between"},
                              alignment: "center",
                              gutter: "12",
                              wrap: false
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  prop: "startDate",
                                  label: "Start Date"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_date_picker, {
                                      format: "DD/MM/YYYY",
                                      placeholder: "DD/MM/YYYY",
                                      type: "date",
                                      modelValue: _ctx.form.startDate,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.startDate) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  prop: "endDate",
                                  label: "End Date"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_date_picker, {
                                      format: "DD/MM/YYYY",
                                      type: "date",
                                      placeholder: "DD/MM/YYYY",
                                      modelValue: _ctx.form.endDate,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.endDate) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_divider),
                            _createVNode(_component_el_form_item, {
                              prop: "compensation",
                              label: "How are you willing to compensate the talent?"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  multiple: "",
                                  modelValue: _ctx.form.compensation,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.compensation) = $event)),
                                  placeholder: "Compensation Method",
                                  "w-100": ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_option, {
                                      value: 'cash',
                                      label: 'Cash'
                                    }),
                                    _createVNode(_component_el_option, {
                                      value: 'equity',
                                      label: 'Equity'
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              prop: "wow",
                              label: "Planned working strategy"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.form.wow,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.wow) = $event)),
                                  placeholder: "Remote, Hybrid",
                                  "w-100": ""
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.wows, (vf) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: `${vf}-wow`,
                                        value: vf,
                                        label: _ctx.$filters.capitalize(vf)
                                      }, null, 8, ["value", "label"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_Transition, { name: "el-zoom-in-top" }, {
                              default: _withCtx(() => [
                                _withDirectives(_createVNode(_component_app_location_search, {
                                  label: "Where is the opportunity based?",
                                  size: 'default',
                                  modelValue: _ctx.form.location,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.location) = $event))
                                }, null, 8, ["modelValue"]), [
                                  [_vShow, _ctx.form.wow == 'physical' || _ctx.form.wow == 'hybrid']
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_divider),
                            _createElementVNode("div", null, [
                              _createVNode(_component_el_checkbox, {
                                onChange: _ctx.changeRegionFilter,
                                modelValue: _ctx.showRegionFilter,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.showRegionFilter) = $event)),
                                size: "large",
                                label: "Add region filtering"
                              }, null, 8, ["onChange", "modelValue"]),
                              _cache[16] || (_cache[16] = _createElementVNode("div", { style: {"margin-bottom":"1.2rem","margin-top":"-8px"} }, [
                                _createElementVNode("small", { class: "mute-secondary" }, " Filter the talents to match with based on either country or region ")
                              ], -1))
                            ]),
                            (_ctx.showRegionFilter && _ctx.form.regionFilter != undefined)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                  _createVNode(_component_el_form_item, {
                                    prop: "regionFilter",
                                    label: "Choose filtering category"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: _ctx.form.regionFilter.type,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.regionFilter.type) = $event)),
                                        placeholder: "Region",
                                        "w-100": "",
                                        onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changeRegionFilterType()))
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regionFilterTypes, (vf) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: `${vf}-regionfilter`,
                                              value: vf,
                                              label: _ctx.$filters.capitalize(vf)
                                            }, null, 8, ["value", "label"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_form_item, {
                                    prop: "regionFilterOption",
                                    label: "Choose region"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: _ctx.form.regionFilter.options,
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.regionFilter.options) = $event)),
                                        placeholder: "Choose",
                                        multiple: "",
                                        filterable: "",
                                        "w-100": ""
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regionOptions, (vf) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: `${vf}-regionfilter-op`,
                                              value: vf,
                                              label: _ctx.$filters.capitalize(vf)
                                            }, null, 8, ["value", "label"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_divider),
                            _createVNode(_component_el_form_item, {
                              prop: "about",
                              label: "Opportunity Description"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  rows: "5",
                                  type: "textarea",
                                  placeholder: "Description",
                                  modelValue: _ctx.form.description,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.description) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model", "rules"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])), [
              [_directive_loading, _ctx.loading]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model-value", "onOpen", "onClose", "title", "show-close", "close-on-click-modal", "close-on-press-escape"])
  ]))
}